export default "__VITE_ASSET__BQhJnCHX__"